import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { ProductWithImage } from 'shared/src/api/types'

import { BookmarkButton } from 'components/BookmarkButton'
import { LinkOrButton } from 'components/LinkOrButton'
import { Views } from 'components/Views'
import { makeProductDetailUrl } from 'utils/routes'
import { FEED_RODEO_PRODUCT_BOOKMARK_Z_INDEX } from 'utils/zIndex'

const useStyles = createUseStyles({
  image: {
    backgroundColor: '#ffffff',
    width: '100%',
  },
  views: {
    position: 'absolute',
    top: 8,
    left: 8,
  },
  bookmark: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: FEED_RODEO_PRODUCT_BOOKMARK_Z_INDEX,
  },
})

interface Props {
  userListId: number
  creatorUsername: string
  creatorId: number
  product: ProductWithImage
  className?: string
}

export const Product: FC<Props> = flowMax(
  addDisplayName('Product'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ userListId, creatorUsername, creatorId, product, classes, className }) => (
    <div className={className}>
      <LinkOrButton
        navigateTo={makeProductDetailUrl(product.id, {
          userListId,
          creatorUsername,
        })}
        showBackButton
      >
        <img
          src={product.image.thumbnail}
          alt={product.name}
          className={classes.image}
        />
        <Views count={product.views ?? 0} className={classes.views} />
      </LinkOrButton>
      <BookmarkButton
        mode="productTile"
        productId={product.id}
        userListId={userListId}
        creatorId={creatorId}
        className={classes.bookmark}
      />
    </div>
  )
)
